"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _green = _interopRequireDefault(require("@material-ui/core/colors/green"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12
    },
    button: {
      overflow: "hidden"
    },
    wrapper: {
      position: "relative",
      display: "inline-block",
      color: "white"
    },
    wrapperFullWidth: {
      width: "100%"
    },
    promiseIconWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      opacity: 0,
      transition: "opacity .3s .3s ease-in-out"
    },
    promiseIcon: {
      color: "white",
      opacity: 0,
      marginTop: 15,
      transition: "opacity .3s .3s ease-in-out, margin-top .3s .3s ease-in-out"
    },

    get promiseSuccessIcon() {
      return _objectSpread({}, this.promiseIconWrapper, {
        backgroundColor: theme.palette.success ? theme.palette.success.main : _green["default"]["A400"]
      });
    },

    checkIcon: {
      width: 20
    },

    get promiseErrorIcon() {
      return _objectSpread({}, this.promiseIconWrapper, {
        backgroundColor: theme.palette.error.main
      });
    },

    closeIcon: {
      width: 20
    },
    showPromiseIcon: {
      opacity: 1,
      transition: "opacity .3s 0s ease-in-out",
      "& $promiseIcon": {
        opacity: 1,
        marginTop: 0,
        transition: "opacity .3s 0s ease-in-out, margin-top .3s 0s ease-in-out"
      }
    }
  };
};

var _default = styles;
exports["default"] = _default;

//# sourceMappingURL=styles.js.map